// -- React and related libs
import React from "react";
import { Switch, Route, Redirect } from "react-router";
import { BrowserRouter } from "react-router-dom";

// -- Redux
import { connect } from "react-redux";

// -- Custom Components
import LayoutComponent from "./components/Layout/Layout";
import ErrorPage from "./pages/error/ErrorPage";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import { HashRouter } from "react-router-dom";
// import './global.css';

// -- Redux Actions
import { logoutUser } from "./actions/auth";

// -- Third Party Libs
import { ToastContainer } from "react-toastify";

// -- Services
import isAuthenticated from "./services/authService";

// -- Component Styles
import "./styles/app.scss";
import Project from "./pages/project/project";
import Dashboard from "./pages/dashboard/Dashboard";
import hasToken from "../src/services/authService";


const App = (props) => {
  return (
    <div>
      {/* <ToastContainer/> */}
      {/* <HashRouter> */}
      
      <HashRouter basename={process.env.PUBLIC_URL}>
        <Switch>
        <Route path="/" exact render={() => <Redirect to="/login" />} />
          <LayoutComponent path="/timeinlive" component={LayoutComponent} />
          <Route path="/login" exact component={Login} />
          <Route path="/error" exact component={ErrorPage} />
          <Route path="/register" exact component={Register} />
          <Route component={ErrorPage}/>
          <Route path='*' exact={true} render={() => <Redirect to="/error" />} />
          </Switch>
          </HashRouter>
        
      {/* </HashRouter> */}
    </div>
  );
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(App);
// export default App;
